import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { httpErrorInterceptor } from './core/interceptor/http-error-interceptor/http-error.interceptor';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
		provideHttpClient(withInterceptors([AuthInterceptor, httpErrorInterceptor])),
		provideAnimations(),

		importProvidersFrom(
			BrowserAnimationsModule,
			ToastrModule.forRoot({
				timeOut: 3000,
				positionClass: 'toast-top-center',
				preventDuplicates: true
			})
		), provideAnimationsAsync()

	]
};